module.exports = __webpack_public_path__ + "static/img/RAOK-1M_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/RAOK-1M_1.png
// module id = LE9y
// module chunks = 0